// Port of api/fuel/app/classes/filter/search/games/sorts/query/ratings.php
import F from 'offline/filter/constants'
import { sorted } from 'offline/filter/core/search/unit'
export default {
	name: '_ratings_auto',
	post: false,
	require: function(config, filter) {
		return config.pseudoType === F.PSEUDO_RATING && !sorted('rating.date', filter)
	},
	run: function(config, filter, data, query) {
		var priority = (config.resultType === F.RESULT_RATING) ? 1001 : 999
		query.order('MAX(r.rating_date)', true, priority)
	}
}
